export default __webpack_public_path__ + "maps-examples-map-snapshotter-thumbnail-480-021b6c98986640ffd1056de0880730c8.webp";